import _ from 'lodash';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Page } from '@janus.team/janus-particles';
import copilot from '@janus.team/janus-copilot/cjs/janus-copilot';

import { OrganizationSummary } from 'organizations/organization-summary';
import * as projects from '../projects/index';

const placeholder = () => <copilot.PlaceholderNavigation context primary />;

const NavigationCore = ({ match: { params: { rackspaceAccountNumber } } }) => {
  const userId = _.get(React.useContext(copilot.context.session), 'session.user.id');

  return (
    <copilot.Catalog
      live
      rackspaceAccountNumber={rackspaceAccountNumber}
      userId={userId}
      placeholder={placeholder}
    >
      {(catalogProps) => (
        <>
          <copilot.PrimaryNavigation {...copilot.mergePrimaryNavigationLinksByRel(
            catalogProps, { 'gcp-projects': { to: `/racker/customers/${rackspaceAccountNumber}` } },
          )}
          />
        </>
      )}
    </copilot.Catalog>
  );
};

const Navigation = withRouter(React.memo(NavigationCore));

export const RackspaceAccount = () => (
  <Page.Main>
    <Navigation />
    <OrganizationSummary />
    <projects.Routes />
  </Page.Main>
);
